import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'components/UIElements'
import { nextOrSkip, nextOrSkipSiblings } from './utils'
import { getShouldDisableSiblingSubmission } from '../utils/instrumentUtils'

export const NextButton = ({
  disabled,
  content,
  completionFunc,
  angleDown = true,
  loading,
}) => {
  return (
    <Button
      primary
      disabled={disabled}
      icon={angleDown ? 'fas fa-angle-down' : ''}
      className='next'
      content={content}
      onClick={completionFunc}
      loading={loading}
    />
  )
}

const Comments = ({ content, strings }) => {
  return (
    <div className='comments'>
      <p className='instructions'>{strings.instructions_comments}</p>
      <span>{content}</span>
    </div>
  )
}

const NavButtons = ({
  backButtonDisabled = false,
  completed,
  id,
  isConsent,
  isLastQuestion,
  loading,
  onComplete,
  renderBackButton,
  required,
  strings,
  siblingId,
  siblingOrder,
  submissionSurvey,
  webSurvey,
}) => {
  let disableForSiblingQuestion = false
  if (siblingOrder) {
    disableForSiblingQuestion = getShouldDisableSiblingSubmission(
      webSurvey,
      submissionSurvey,
      siblingOrder,
    )
  }

  const isLastConsentQuestion = isLastQuestion && isConsent

  const checkIfDisabled = () => {
    if (loading) return true
    return siblingOrder ? disableForSiblingQuestion : required && !completed
  }

  return (
    <div className={`button-list${siblingId ? ' for-siblings' : ''}`}>
      {renderBackButton(id, backButtonDisabled)}
      <NextButton
        disabled={checkIfDisabled()}
        content={
          siblingOrder
            ? nextOrSkipSiblings(
                webSurvey,
                submissionSurvey,
                siblingOrder,
                strings,
              )
            : isLastConsentQuestion
              ? strings.survey_finish
              : nextOrSkip(required, completed, strings)
        }
        completionFunc={onComplete}
        loading={loading}
      />
    </div>
  )
}

const QuestionFooter = ({
  backButtonDisabled = false,
  completed,
  hideComments = false,
  id,
  isLastQuestion,
  onComplete,
  question = {},
  renderBackButton,
  siblingId,
  siblingOrder,
  strings,
  submissionSurvey,
  webSurvey = {},
  isConsent,
  loading,
}) => {
  const { comments, attributes = {} } = question
  const { required } = attributes

  return (
    <>
      {!hideComments && comments && (
        <Comments content={comments} strings={strings} />
      )}
      <NavButtons
        backButtonDisabled={backButtonDisabled}
        completed={completed}
        id={id}
        isConsent={isConsent}
        isLastQuestion={isLastQuestion}
        loading={loading}
        onComplete={onComplete}
        renderBackButton={renderBackButton}
        required={required}
        siblingId={siblingId}
        siblingOrder={siblingOrder}
        strings={strings}
        submissionSurvey={submissionSurvey}
        webSurvey={webSurvey}
      />
    </>
  )
}

export default QuestionFooter

NextButton.propTypes = {
  disabled: PropTypes.bool,
  content: PropTypes.string,
  completionFunc: PropTypes.func,
}

QuestionFooter.propTypes = {
  backButtonDisabled: PropTypes.bool,
  completed: PropTypes.bool,
  hideComments: PropTypes.bool,
  id: PropTypes.string,
  isConsent: PropTypes.bool,
  isLastQuestion: PropTypes.bool,
  loading: PropTypes.bool,
  onComplete: PropTypes.func,
  renderBackButton: PropTypes.func,
  strings: PropTypes.objectOf(PropTypes.string),
  question: PropTypes.shape({
    comments: PropTypes.string,
    attributes: PropTypes.objectOf(PropTypes.any),
  }),
  siblingId: PropTypes.string,
  siblingOrder: PropTypes.arrayOf(PropTypes.string),
  submissionSurvey: PropTypes.object,
  webSurvey: PropTypes.object,
}

NavButtons.propTypes = QuestionFooter.propTypes
Comments.propTypes = QuestionFooter.propTypes
